import React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import LanguageButton from 'components/atoms/LanguageButton';
import SocialMedia from 'components/atoms/SocialMedia';
import LogoIcon from 'images/icon/logo-black.inline.svg';
import styles from './index.css';

const Footer = ({ lan, mapLanguage, t }) => (
	<footer
		className={classnames(styles.footer, {
			[styles.englishWording]: lan === 'en',
		})}
	>
		<div className={styles.footerTop}>
			<div className={styles.footerSitemap}>
				<div className={styles.column}>
					<h5>{t('room')}</h5>
					<Link to={`/${mapLanguage}/room`}>{t('filter')}</Link>
					<Link to={`/${mapLanguage}/map`}>{t('map')}</Link>
					<a
						href="https://pure.9floor.co/"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('pauian')}
					</a>
				</div>
				<div className={styles.column}>
					<h5>{t('ninthfloor')}</h5>
					<Link to={`/${mapLanguage}/about`}>{t('about')}</Link>
					<Link to={`/${mapLanguage}/team`}>{t('team')}</Link>
					<Link to={`/${mapLanguage}/space`}>{t('space')}</Link>
					<Link to={`/${mapLanguage}/coliving`}>{t('coliving')}</Link>
					<a
						href="https://medium.com/9floor-co-living/tagged/9fnews"
						target="_blank"
						rel="noopener noreferrer"
					>
						{t('news')}
					</a>
				</div>
				<div className={styles.column}>
					<h5>{t('help')}</h5>
					<Link to={`/${mapLanguage}/service`}>{t('how')}</Link>
					<a href="https://medium.com/9floor-co-living" target="_blank" rel="noopener noreferrer">
						{t('FAQ')}
					</a>
					<Link to={`/${mapLanguage}/contact`}>{t('contact')}</Link>
					<Link href={`/${mapLanguage}/media`}>{t('media')}</Link>
				</div>
			</div>
			<div className={styles.footerInfo}>
				<div className={styles.logo}>
					<LogoIcon />
				</div>
				{/* <img alt="" src={logo} /> */}
				<LanguageButton className={styles.lanButton} />
				<SocialMedia />
			</div>
		</div>
		<div className={styles.footerBottom}>
			<span>
				<span role="img" aria-labelledby="copy-right">
					©
				</span>玖樓 9floor 2019
			</span>
			<div className={styles.footerPolicy}>
				<Link to={`/${mapLanguage}/terms`}>
					<span>{t('termsofService')}</span>
				</Link>
				<Link to={`/${mapLanguage}/service`}>
					<span>{t('description')}</span>
				</Link>
				<Link to={`/${mapLanguage}/privacy`}>
					<span>{t('privacy')}</span>
				</Link>
				<Link to={`/${mapLanguage}/sitemap`}>
					<span>{t('sitemap')}</span>
				</Link>
			</div>
		</div>
	</footer>
);

export default translate('footer')(Footer);



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/component.js